import _ from "lodash";
import brandsConstants from "./brands";
import constants from "../../common/constants";

class DomainHelper {
  static getMyDomainObject() {
    if (process.env.REACT_APP_ENV !== "production") {
      const brandFromLocalStorage = localStorage.getItem("brand");

      if (brandFromLocalStorage) {
        return brandsConstants.brands[brandFromLocalStorage];
      }
    }

    const currentDomain = window.location.href;
    let res = {};
    if (currentDomain) {
      _.each(brandsConstants.brands, function(item) {
        return _.find(item.domains, function(domain) {
          if (currentDomain.startsWith(domain)) res = item;
        });
      });
    }
    return res || brandsConstants.brands.healo;
  }

  static getDefaultLanguage(brand) {
    brand = brand || DomainHelper.getMyDomainObject();
    if (!brand.defaultLanguage) return null;

    const currentDomain = window.location.href;
    for (let language of brand.defaultLanguage) {
      for (let test of language.test) {
        if (new RegExp(test).test(currentDomain)) {
          return language.language;
        }
      }
    }

    return null;
  }

  static getDownloadLinks(brand) {
    brand = brand || DomainHelper.getMyDomainObject();

    return brand.downloadLinks || constants.downloadLinks;
  }
}

export default DomainHelper;



// WEBPACK FOOTER //
// ./src/modules/brand/brand-helper.js